export default __webpack_public_path__ + "static/media/paysage.2accfa9d.svg";